import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heading } from '@tw/tw-component-library/common-wt';
import {
  SidebarContainer,
  SidebarContent,
  ToggleButton,
  SidebarItem,
} from './styles';
import { SidebarProps } from './types';

export const Sidebar = ({
  isOpen,
  setIsOpen,
  position = 'left',
  items = [],
  children,
  toggleIcon,
}: SidebarProps) => {
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState('');

  const handleNavigation = (path: string) => {
    if (path) {
      setActivePage(path);
      navigate(`${path}`);
    }
  };

  return (
    <SidebarContainer $isOpen={isOpen} $position={position}>
      {toggleIcon && (
        <ToggleButton onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? toggleIcon.open : toggleIcon.closed}
        </ToggleButton>
      )}
      <SidebarContent $isOpen={isOpen}>
        {items.length > 0
          ? items.map((item, index) => (
              <SidebarItem
                key={`${item.id}-${index}`}
                $isActive={activePage === item.path}
                onClick={() => handleNavigation(item.path || '')}
              >
                {item.icon}
                <Heading typeSet="ui1" onDark={true}>{item.label}</Heading>
              </SidebarItem>
            ))
          : children}
      </SidebarContent>
    </SidebarContainer>
  );
};
